export default [

     {
          path: '/third-party-assessment-result',
          name: 'ThirdPartyAssessmentResult',
          component: () => import("@/views/Page/ThirdPartyAssessmentResult/ThirdPartyAssessmentResult.vue"),
           meta: {
               title: 'ThirdPartyAssessmentResult',
          },
     }
];